import React from 'react';
import './Footer.css';
import logo from '../Assets/e63713dc-eda5-452c-8fae-4493d520803b_removalai_preview 1.png'; // Remplace par le chemin de ton logo

// Importer Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Div 1 : Logo et texte */}
        <div className="footer-logo">
          <img src={logo} alt="Logo" className="logo-img" />
          <p> Saqr Technology se spécialise dans les solutions <span> et composants d'automatisation pour objectif</span>
           <span>  principal d’offrir des services d’ingénierie</span> <span> professionnels adaptés aux besoins</span> <span> spécifiques de ses clients</span> </p>
          
        </div>

        {/* Div 2 : Liens */}
        <div className="footer-links">
          <h3>Liens</h3>
          <ul>
            <li><a href="/">Accueil</a></li>
            <li><a href="/about">À propos</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Div 3 : Certifications */}
        <div className="footer-certifications">
          <h3>Certifications</h3>
          <ul>
            <li>ISO 9001</li>
            <li>Certification Éco-Responsable</li>
            <li>Partenaire Certifié</li>
          </ul>
        </div>

        {/* Div 4 : Contact */}
        <div className="footer-contact">
          <h3>Contactez-nous</h3>
          <ul>
            <li>
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
              Email : Info@saqrts.com
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: '8px' }} />
              Téléphone : +213 557111117
            </li>
            <li>
              <FontAwesomeIcon icon={faLocationDot} style={{ marginRight: '8px' }} />
              Adresse : Constantine, Cité Ali mendjeli-Aïn El Bey, El kharoub, B 5A,N°172.
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;